// Create and setup your form here
 
<template>
  <div>
    <header class="vff-header">
      <div class="f-container">
       <!-- Add custom logo here -->
        <!-- <svg class="f-logo" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMid meet" viewBox="0 0 35.606 11.211">
          <path d="M.134.837H3.21V8.01h4.203v2.18H.134V.837z"/>
          <path d="M11.875.59c1.48 0 2.668.448 3.567 1.344s1.35 2.052 1.35 3.47c0 1.48-.445 2.7-1.336 3.632S13.38 10.45 11.9 10.45c-1.678 0-2.954-.54-3.827-1.622-.717-.9-1.08-2.022-1.09-3.397-.01-1.36.39-2.484 1.193-3.374C9.06 1.08 10.292.59 11.875.59zm0 2.283c-.563 0-1.003.222-1.323.662-.338.467-.507 1.124-.507 1.972 0 .865.162 1.524.487 1.978a1.58 1.58 0 0 0 1.369.682c.588 0 1.04-.223 1.355-.668s.474-1.07.474-1.875c0-1.834-.62-2.75-1.855-2.75z"/>
          <path d="M21.565 7.078V5.055h4.217v5.163h-1.986l-.13-.908c-.693.76-1.617 1.142-2.777 1.142-1.383 0-2.488-.437-3.313-1.3s-1.243-2.03-1.252-3.464c-.01-1.462.385-2.65 1.18-3.567.875-1.012 2.11-1.518 3.7-1.518 1.21 0 2.207.303 3 .907s1.264 1.457 1.447 2.556h-2.92c-.207-.787-.73-1.182-1.57-1.182-.553 0-.988.236-1.303.707s-.475 1.153-.475 2.043c0 1.695.652 2.542 1.96 2.542.363 0 .695-.103.998-.306a1.29 1.29 0 0 0 .572-.784h-1.35v.002z"/>
          <path d="M30.556.59c1.48 0 2.668.448 3.568 1.344s1.348 2.052 1.348 3.47c0 1.48-.443 2.7-1.336 3.632S32.06 10.45 30.58 10.45c-1.678 0-2.953-.54-3.826-1.622-.72-.892-1.082-2.022-1.1-3.398-.008-1.357.39-2.48 1.193-3.372C27.74 1.08 28.974.59 30.556.59zm0 2.283c-.563 0-1.002.222-1.322.662-.336.467-.506 1.125-.506 1.972 0 .865.162 1.524.486 1.978s.78.682 1.37.682 1.04-.223 1.355-.668.475-1.07.475-1.875c-.002-1.834-.62-2.75-1.857-2.75z"/>
        </svg>-->
      </div>
    </header>
    <div ><article v-if="background"><img style="float: right;" src="../questionnaire/assets/images/SunIntro.png"  ></article>  

    <flow-form
      ref="flowform"
      v-bind:showTime="showTime0"
      v-on:complete="onComplete"
      v-on:submit="onSubmit"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:standalone="true"
    >
        <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
     
      <template v-slot:complete>
        <p><!-- 
          <span class="fh2">Συγχαρητήρια!</span>
          <span v-if="!submitted" class="f-section-text">
            Επίλεξε το "Υπολογίσμος σκορ" για να δεις τα αποτελέσματα του τεστ.
          </span>-->
        </p>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit" v-if="submitted">
          <button 
            class="o-btn-action"
            ref="button"
            type="submit"
            href="#"
            v-on:click.prevent="onSendData()"
            aria-label="Καταχώρηση"
          >
            <span>{{ language.submitText }}</span>
          </button>
          <a class="f-enter-desc"
            href="#"
            v-on:click.prevent="onSendData()"
            v-html="language.formatString(language.pressEnter)">
          </a>
        </div>

        <p class="text-success" v-if="submitted">Καταχώρηση επιτυχές. </p>
      </template>
    </flow-form>
  


    <flow-form v-if ="showTime1"
      ref="flowform1"
      v-bind:showTime="showTime1"
      v-on:complete="onComplete1"
      v-on:submit="onQuizSubmit"
      v-bind:questions="questions1Shuffle"
      v-bind:language="language"
      v-bind:standalone="true"
      v-bind:timer="false"
      v-bind:navigation="false"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
    
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
       <p> <!-- 
          <span class="fh2">Συγχαρητήρια!</span>
          <span v-if="!submitted" class="f-section-text">
            Επίλεξε το "Υπολογίσμος σκορ" για να δεις τα αποτελέσματα του τεστ.
          </span>-->
        </p>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <p class="text-success" v-if="calcflag && time">Your time: {{ formattedTime }}</p>
        <p class="text-success" v-if="calcflag && score < 4">"Tελικό σκορ, {{ score }} / {{ total }}. "</p>
        <p class="text-success" v-else-if="calcflag && score < 7">"Tελικό σκορ,  {{ score }} / {{ total }}. "</p>
        <p class="text-success" v-else-if="calcflag && score <= total">"Tελικό σκορ,  {{ score }} / {{ total }}. "</p>

        <img  v-if="calcflag" style="float: right; width: 13%" src="../../examples/questionnaire/assets/images/images/arrowt.png" alt="Next" ref="button" v-on:click.prevent="flowChange" v-bind:aria-label="language.ariaOk">

      </template>
    </flow-form>
  

    <flow-form
      ref="flowform2"
      v-bind:showTime="showTime2"
      v-on:complete="onComplete2"
      v-on:submit="onQuizSubmit2"
      @custom-event-totalpoints="SavePointsEvent"
      v-bind:questions="questions2"
      v-bind:language="language"
      v-bind:standalone="true"
      v-bind:timer="false"
      v-bind:navigation="false"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
    <p>
           <!--    <span class="fh2">Συγχαρητήρια!</span>
          <span v-if="!submitted" class="f-section-text">
            Επίλεξε το "Υπολογίσμος σκορ" για να δεις τα αποτελέσματα του τεστ.
          </span>-->
        </p>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>      
      </template>
    </flow-form>

    <flow-form v-if ="showTime2a"
      ref="flowform2a"
      v-bind:showTime="showTime2a"
      v-on:complete="onComplete2a"
      v-on:submit="onQuizSubmit2a"
      v-bind:questions="questions2a"
      v-bind:pointsTot="pointsTotal"
      v-bind:language="language"
      v-bind:standalone="true"
      v-bind:timer="false"
      v-bind:navigation="false"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
    
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
    <p>
           <!--    <span class="fh2">Συγχαρητήρια!</span>
          <span v-if="!submitted" class="f-section-text">
            Επίλεξε το "Υπολογίσμος σκορ" για να δεις τα αποτελέσματα του τεστ.
          </span>-->
        </p>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>      
      </template>
    </flow-form>

    <flow-form v-if ="showTime3"
      ref="flowform3"
      v-bind:showTime="showTime3"
      v-on:complete="onComplete3"
      v-on:submit="onQuizSubmit3"
      @custom-event-totalpoints="SavePointsEventFinal"
      v-bind:questions="questions3Shuffle"
      v-bind:pointsTot="pointsTotal"
      v-bind:language="language"
      v-bind:standalone="true"
      v-bind:timer="false"
      v-bind:navigation="false"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
    
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
       <p>  
          <span  v-if="!finito"  class="fh2">Συγχαρητήρια, έφτασες με επιτυχία στη
Χώρα του Ήλιου.</span>
        </p>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <!-- <span>Συγχαρητήρια, έφτασες με επιτυχία στη
Χώρα του Ήλιου.</span> -->
<p class="text-success" v-if="calcflag && time">Your time: {{ formattedTime }}</p>
        <p class="text-success" v-if="calcflag && !finito && scorefinal < 4">"Tελικό σκορ, {{ scorefinal }} / {{ total }}. "</p>
        <p class="text-success" v-else-if="calcflag && !finito && scorefinal < 7">"Tελικό σκορ,  {{ scorefinal }} / {{ total }}. "</p>
        <p class="text-success" v-else-if="calcflag && !finito && scorefinal <= total">"Tελικό σκορ,  {{ scorefinal }} / {{ total }}. "</p>
        <span  v-if="!finito" >ΤΟ ΠΑΙΧΝΙΔΙ ΟΛΟΚΛΗΡΩΘΗΚΕ. ΤΕΛΙΚΟ ΣΚΟΡ: {{ pointsTotalFinal }}</span>
        <br>
        <button v-if="!finito" 
              class="button-gradient"
              ref="button" 
              type="button" 
              href="#" 
              v-on:click.prevent="ranktable" 
              >
                <span>ΠΙΝΑΚΑΣ ΚΑΤΑΤΑΞΗΣ</span>
            </button>
            <br><br><br>
        <button v-if="!finito" 
              class="button-gradient"
              ref="button" 
              type="button" 
              href="#" 
              v-on:click.prevent="finalstep" 
              >
                <span>ΕΞΟΔΟΣ</span>
            </button>
            <br><br><br>
        <button v-if="!finito" 
              class="button-gradient"
              ref="button" 
              type="button" 
              href="#" 
              v-on:click.prevent="startagain" 
              >
                <span>ΠΑΙΧΝΙΔΙ</span>
            </button>
            <p v-if="finito" >  
          <span class="fh2">Μην ξεχνάς ποτέ την προστατευτική πανοπλία σου, όταν είσαι στον ήλιο! </span>
        </p>
      </template>
    </flow-form>

    <flow-form v-if ="showTime4"
      ref="flowform4"
      v-bind:showTime="showTime4"
      v-on:complete="onComplete4"
      v-on:submit="onQuizSubmit4"
      @custom-event-totalpoints="SavePointsEventFinal"
      v-bind:questions="questions4"
      v-bind:pointsTot="pointsTotal"
      v-bind:language="language"
      v-bind:standalone="true"
      v-bind:timer="false"
      v-bind:navigation="false"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
    
      <!-- We've overriden the default "complete" slot content -->
      <template v-slot:complete>
        <p></p>
       <p v-if ="!finaloptions">  
        <table id="data-table">
    <thead>
        <tr>
            <th>Name</th>
            <th>Points</th>
        </tr>
    </thead>
    <tbody>
        <!-- JavaScript will insert rows here -->
    </tbody>
</table>
        </p>
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <!-- <span>Συγχαρητήρια, έφτασες με επιτυχία στη
Χώρα του Ήλιου.</span> -->
<img  v-if="calcflag && !finito && !finaloptions" style="float: right; width: 13%" src="../../examples/questionnaire/assets/images/images/arrowt.png" alt="Next" ref="button" v-on:click.prevent="showEndSlide" v-bind:aria-label="language.ariaOk">
 <br>
        <button v-if="!finito && finaloptions" 
              class="button-gradient"
              ref="button" 
              type="button" 
              href="#" 
              v-on:click.prevent="finalstep" 
              >
  
                <span>ΕΞΟΔΟΣ</span>
            </button>
            <br><br><br>
        <button v-if="!finito && finaloptions" 
              class="button-gradient"
              ref="button" 
              type="button" 
              href="#" 
              v-on:click.prevent="startagain" 
              >
                <span>ΠΑΙΧΝΙΔΙ</span>
            </button>
            <p v-if="finito" >  
          <span class="fh2">Μην ξεχνάς ποτέ την προστατευτική πανοπλία σου, όταν είσαι στον ήλιο! </span>
        </p>
      </template>
    </flow-form>

  </div>
  </div>
</template>

<script>
  /*
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://www.ditdot.hr/en
  */

  // Import necessary components and classes
  import FlowForm from '../../src/components/FlowForm.vue'

  import QuestionModel, { QuestionType, ChoiceOption, LinkOption } from '../../src/models/QuestionModel'
  import LanguageModel from '../../src/models/LanguageModel'
  // If using the npm package, use the following line instead of the ones above.
  // import FlowForm, { QuestionModel, QuestionType, ChoiceOption, LanguageModel } from '@ditdot-dev/vue-flow-form'

  export default {
    name: 'example',
    components: {
      FlowForm
      
    },

    data() {
      return {
            showTime0: true,
            showTime1: false,
            showTime2: false,
            showTime2a: false,
            showTime3: false,
            showTime4: false,
            storyCount: 0,
            submitted: false,
            submitted1: false,
            submitted2: false,
            completed: false,
            completed1: false,
            completed2: false,
            background: true,
            score: 0, 
            scorefinal:0,
            total: 11, 
            time: 0,
            calcflag:false,
            username:0,
            finito:false,
            formattedTime: '',
            pointsTotal:0,
            finaloptions:false,
            pointsTotalFinal:0,
            ranked_data : [
        { name: "Alice", points: 85 },
        { name: "Bob", points: 92 },
        { name: "Charlie", points: 78 },
        { name: "Diana", points: 88 },
        { name: "Edward", points: 95 }
    ],
            language: new LanguageModel({
              continue: 'Επόμενο',
              pressEnter: 'πατήστε το ENTER',
              submitText: 'Καταχώρηση',
            }),
            answers: {
              ux_1: 'true', 
              ux_2: 'true', 
              ux_3: 'false', 
              ux_4: 'true', 
              ux_5: 'false', 
              ux_6: 'false', 
              ux_7: 'true', 
              ux_8: 'false', 
              ux_9: 'true', 
              ux_10: 'true', 
              ux_11: 'true'
            },

            answersfinal: {
              fq_1: 'true', 
              fq_2: 'true', 
              fq_3: 'false', 
              fq_4: 'true', 
              fq_5: 'true', 
              fq_6: 'true', 
              fq_7: 'false', 
              fq_8: 'true', 
              fq_9: 'false', 
              fq_10: 'true', 
              fq_11: 'false'
            },
            // Create question list with QuestionModel instances
            questions: [
            new QuestionModel({
                id: 'unique_num',
                tagline: 'Γεία σου! Καλωσόρισες στην ιστοσελίδα για την Υπεριώδη ακτινοβολία 😊',
                subtitle: 'Αυτός είναι ο μοναδικός σου κωδικος',
                type: QuestionType.Text,
                required: false,
                disabled: true,
                hero : false,
                bar : false,
              }), new QuestionModel({
                id: 'gender',
                subtitle: 'Φύλο:',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                allowOther: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'Αγόρι'
                  }),
                  new ChoiceOption({
                    label: 'Κορίτσι'
                  })
                ]
              }), new QuestionModel({
                id: 'age',
                subtitle: 'Ηλικία:',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                allowOther: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: '9'
                  }),
                  new ChoiceOption({
                    label: '10'
                  }),
                  new ChoiceOption({
                    label: '11'
                  }),
                  new ChoiceOption({
                    label: '12'
                  })
                ]
              }), new QuestionModel({
                id: 'class',
                subtitle: 'Τάξη:',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                allowOther: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'Γ ΤΑΞΗ'
                  }),
                  new ChoiceOption({
                    label: 'Δ ΤΑΞΗ'
                  }),
                  new ChoiceOption({
                    label: 'Ε ΤΑΞΗ'
                  }),
                  new ChoiceOption({
                    label: 'ΣΤ ΤΑΞΗ'
                  })
                ]
              }), new QuestionModel({
                id: 'city',
                subtitle: 'Επαρχία:',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                allowOther: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'Λευκωσία'
                  }),
                  new ChoiceOption({
                    label: 'Λάρνακα'
                  }),
                  new ChoiceOption({
                    label: 'Λεμεσός'
                  }),
                  new ChoiceOption({
                    label: 'Πάφος'
                  }),
                  new ChoiceOption({
                    label: 'Αμμόχωστος'
                  })
                ]
              })
            ],
            questions1: [
            new QuestionModel({
                id: 'start',
                subtitle: 'Πόσα γνωρίζεις για την υπεριώδη ακτινοβολία;',
                content: 'Έλεγξε τις γνώσεις σου πριν προχωρήσεις στο παιχνίδι.',
                type: QuestionType.SectionBreak,
                required: true,
              }),
              new QuestionModel({
                id: 'ux_1',
                subtitle: 'Η υπεριώδης ακτινοβολία είναι ένα είδος ηλιακής ακτινοβολίας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_2',
                subtitle: 'Πρέπει να φοράμε γυαλιά ηλίου όταν είμαστε στον ήλιο, γιατί ο ήλιος μπορεί να βλάψει τα μάτια μας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_3',
                subtitle: 'Όλα τα γυαλιά ηλίου προστατεύουν τα μάτια από την υπεριώδη ακτινοβολία του ήλιου.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_4',
                subtitle: 'Όταν ο δείκτης UV είναι στο 2, τότε μπορούμε να μείνουμε όση ώρα θέλουμε στον ήλιο, χωρίς προστασία.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_5',
                subtitle: 'Όταν βάζεις αντηλιακό δε χρειάζεται να φοράς καπέλο ή γυαλιά όταν βρίσκεσαι στον ήλιο.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_6',
                subtitle: 'Ένα αντηλιακό με δείκτη προστασίας 15, είναι αρκετό για να μας προστατέψει.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_7',
                subtitle: 'Αρκετή ώρα στον ήλιο χωρίς προστασία μπορεί να κάνει κακό στο δέρμα και στα μάτια.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_8',
                subtitle: 'Το επίπεδο υπεριώδους ακτινοβολίας είναι ψηλό όλη τη διάρκεια της μέρας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_9',
                subtitle: 'Ο δείκτης UV (UV index) μας δείχνει το επίπεδο επικινδυνότητας της υπεριώδους ακτινοβολίας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),
              new QuestionModel({
                id: 'ux_10',
                subtitle: 'Επιλέγουμε αντηλιακά ευρέως φάσματος, γιατί μας προστατεύουν από τις UVA και UVB.Η υπεριώδης ακτινοβολία είναι ένα είδος ηλιακής ακτινοβολίας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }),new QuestionModel({
                id: 'ux_11',
                subtitle: 'Βάζοντας μια φορά αντηλιακό, προστατεύεις το δέρμα σου για τουλάχιστον 4 ώρες.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ]
              }) 
            
            ],
            questions2: [
            new QuestionModel({
                id: 'id1',
                title: 'ΑΠΟΣΤΟΛΗ',
                content: 'Είσαι έτοιμος/η να ταξιδέψεις στη χώρα του Ήλιου; Στη χώρα του Ήλιου, υπάρχει διαρκώς ηλιοφάνεια σχεδόν το μεγαλύτερο μέρος της μέρας. Φτάνοντας εκεί θα πρέπει να φοράς την κατάλληλη πανοπλία που θα σε προστατέψει από την έντονη ηλιακή ακτινοβολία. Με κάθε δοκιμασία που θα ξεπερνάς θα κερδίζεις και ένα μέρος της πανοπλίας που θα σε προστατέψει από την έντονη ακτινοβολία στη Χώρα του Ήλιου.', 
                type: QuestionType.SectionBreak,
                required: true,
                hero: true,
                correct :2
              }),
              new QuestionModel({
                id: 'id2',
                content: 'Ανάμεσα στις ηλιακές ακτίνες που φτάνουν στην επιφάνεια της γης είναι και οι υπεριώδεις ακτίνες. Αυτές, μπορούν να γίνουν επικίνδυνες για τον άνθρωπο. Παρακολούθησε το βίντεο που ακολουθεί για να μάθεις τι είναι η υπεριώδης ακτινοβολία και πότε αυτή γίνεται επικίνδυνη.', 
                type: QuestionType.SectionBreak,
                required: true,
                hero: true,
                correct :2
              }),
              new QuestionModel({
                id: 'id2a',
                type: QuestionType.SectionBreak,
                required: true,
                video: true
              }),
              new QuestionModel({
                id: 'id3',
                content: 'Ας θυμηθούμε τι έχουμε μάθει για την υπεριώδη ακτινοβολία. Ανάμεσα στις ακτίνες που στέλνει ο ήλιος στη Γη είναι και οι υπεριώδεις ακτίνες ή η υπεριώδης ακτινοβολία. Διακρίνεται σε UVA, UVB και UVC. Η UVA και UVB φτάνουν στην επιφάνεια της Γης. Η έκθεση σε μικρές ποσότητες στη UVB βοηθά το ανθρώπινο σώμα στη σύνθεση της βιταμίνης D. Η παρατεταμένη όμως έκθεση στις υπεριώδεις ακτίνες προκαλούν βλάβες στα μάτια και στο δέρμα εκ των οποίων κάποιες είναι πολύ σοβαρές.', 
                type: QuestionType.SectionBreak,
                required: true,
                scientist:true,
                bar:true,
                correct :2
              }),
              new QuestionModel({
                id: 'id4',
                content: 'Ο δείκτης υπεριώδους ακτινοβολίας ή δείκτης UV είναι ένα παγκόσμιο μέγεθος που δηλώνει με χρώματα και αριθμούς την επικινδυνότητα της υπεριώδους ακτινοβολίας σε μια συγκεκριμένη περιοχή. Όταν ο δείκτης φτάσει ή ξεπεράσει το 3 δημιουργεί βλάβες στα μάτια και στο δέρμα.', 
                type: QuestionType.SectionBreak,
                required: true,
                scientist:true,
                bar:true,
                correct :2
              }),
                new QuestionModel({
                id: 'id5',
                content: 'Κατά τη διάρκεια της μέρας το επίπεδο υπεριώδους ακτινοβολίας δεν είναι πάντα το ίδιο. Ο δείκτης UV μας βοηθά να ερμηνεύσουμε το επίπεδο επικινδυνότητας της υπεριώδους ακτινοβολίας και καθορίζει τις ενέργειες που πρέπει να λάβουμε για προστασία. Μελέτησε τον δείκτη UV και πώς τον χρησιμοποιούμε στο διάγραμμα που ακολουθεί.', 
                type: QuestionType.SectionBreak,
                required: true,
                scientist:true,
                bar:true,
                correct :2
              }),    new QuestionModel({
                id: 'id5a',
                content: 'UV Index διάγραμμα', 
                type: QuestionType.SectionBreak,
                required: true,
                uvmeterbar:true,
                bar:true
              }),
              new QuestionModel({
                id: 'id6',
                content: 'Έλεξε τώρα τις γνώσεις σου, για να ολοκληρώσεις την πρώτη αποστολή. Στο πάνω αριστερά μέρος της οθόνης σου θα βλέπεις το μέρος της πανοπλίας που έχεις εξασφαλίσει ενώ στο πάνω δεξιά μέρος της οθόνης σου τα νομίσματα που έχεις κερδίσει.', 
                type: QuestionType.SectionBreak,
                required: true,
                scientist:true,
                bar:true,
                correct :2
              }),
              new QuestionModel({
                id: 'dx_1',
                subtitle: 'Ο δείκτης UV (UVΙndex) δείχνει τον βαθμό επικινδυνότητας της υπεριώδους ακτινοβολίας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                bar:true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],jump: {
                    true: 'dx_1_a',
                    false: 'dx_1_b'
                  }
              }),
              new QuestionModel({
                id: 'dx_1_a',
                content: 'Μπράβο! Ο δείκτης UV δείχνει με χρώματα και αριθμούς τον βαθμό επικινδυνότητας της υπεριώδους ακτινοβολίας σε μια συγκεκριμένη περιοχή.', 
                type: QuestionType.SectionBreak,
                required: true,
                bar:true,
                scientist:true,
                correct:2,
                jump: {
                    _other: 'dx_2'
                  },
                point: 5
              }),
              new QuestionModel({
                id: 'dx_1_b',
                content: 'Κι όμως ο δείκτης UV είναι ένα παγκόσμιο μέγεθος και δείχνει με χρώματα και αριθμούς τον βαθμό επικινδυνότητας της υπεριώδους ακτινοβολίας σε μια συγκεκριμένη περιοχή.', 
                type: QuestionType.SectionBreak,
                bar:true,
                required: true,
                scientist:true,
                correct:1,
                jump: {
                    _other: 'dx_2'
                  }
              }),
              new QuestionModel({
                id: 'dx_2',
                subtitle: 'Όταν ο δείκτης UV φτάσει ή ξεπεράσει το 3,τότε προκαλεί βλάβες στα μάτια και στο δέρμα.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],jump: {
                    true: 'dx_2_a',
                    false: 'dx_2_b'
                  }
              }),
              new QuestionModel({
                id: 'dx_2_a',
                content: 'Πολύ σωστά! Οποιαδήποτε τιμή στον δείκτη UV από 3 και πάνω μπορεί να προκαλέσει βλάβες στο δέρμα και στα μάτια!', 
                type: QuestionType.SectionBreak,
                bar:true,
                required: true,
                scientist:true,
                correct:2,
                jump: {
                    _other: 'dx_3'
                  },
                point:5
              }),
              new QuestionModel({
                id: 'dx_2_b',
                content: 'Προσοχή! Στις περιπτώσεις που η τιμή στον δείκτη UV είναι από 0-2, η υπεριώδης ακτινοβολία δεν μπορεί να προκαλέσει βλάβες στον άνθρωπο!Έλεξε τώρα τις γνώσεις σου, για να ολοκληρώσεις την πρώτη αποστολή. Στο πάνω αριστερά μέρος της οθόνης σου θα βλέπεις το μέρος της πανοπλίας που έχεις εξασφαλίσει ενώ στο πάνω δεξιά μέρος της οθόνης σου τα νομίσματα που έχεις κερδίσει. Έλεγξε τις γνώσεις σου για να ολοκληρώσεις την πρώτη σου αποστολή!', 
                type: QuestionType.SectionBreak,
                bar:true,
                required: true,
                scientist:true,
                correct:1,
                jump: {
                    _other: 'dx_3'
                  }
              }),
              new QuestionModel({
                id: 'dx_3',
                subtitle: 'Κατά τις μεσημβρινές ώρες ο δείκτης UV έχει μικρότερες τιμές.Όλα τα γυαλιά ηλίου προστατεύουν τα μάτια από την υπεριώδη ακτινοβολία του ήλιου.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],jump: {
                    true: 'dx_3_a',
                    false: 'dx_3_b'
                  }
              }),
              new QuestionModel({
                id: 'dx_3_a',
                content: 'Προσοχή! Ο δείκτης UV έχει μικρότερες τιμές κατά τις πρωινές και απογευματινές ώρες της ημέρας!Έλεξε τώρα τις γνώσεις σου, για να ολοκληρώσεις την πρώτη αποστολή. Στο πάνω αριστερά μέρος της οθόνης σου θα βλέπεις το μέρος της πανοπλίας που έχεις εξασφαλίσει ενώ στο πάνω δεξιά μέρος της οθόνης σου τα νομίσματα που έχεις κερδίσει. Έλεγξε τις γνώσεις σου για να ολοκληρώσεις την πρώτη σου αποστολή!', 
                type: QuestionType.SectionBreak,
                bar:true,
                required: true,
                scientist:true,
                correct:1,
                jump: {
                    _other: 'dx_4'
                  }
              }),
              new QuestionModel({
                id: 'dx_3_b',
                content: 'Πολύ σωστά! Τις μεσημβρινές ώρες ο δείκτης UV είναι ψηλότερος από οποιαδήποτε άλλη ώρα της ημέρας! Όσο πιο ψηλός, τόσο πιο επικίνδυνος.', 
                type: QuestionType.SectionBreak,
                bar:true,
                required: true,
                scientist:true,
                correct:2,
                jump: {
                    _other: 'dx_4'
                  },
                point:5
              }),     
              new QuestionModel({
                id: 'dx_4',
                content: 'Συγχαρητήρια! Ολοκλήρωσες επιτυχώς την 1η δοκιμασία και κατέκτησες το UV index. Αυτό θα σε βοηθήσει να ξέρεις κάθε φορά σε ποιο επίπεδο βρίσκεται η υπεριώδης ακτινοβολία.', 
                type: QuestionType.SectionBreak,
                bar:true,
                uvindex:true,
                required: true,
                contenthidden :'Πόση να είναι τώρα άραγε, η υπεριώδης ακτινοβολία;'
              }),
              new QuestionModel({
                id: 'dx_5',
                content: 'Είναι 8 το πρωί. Σε τι επίπεδο να βρίσκεται άραγε η υπεριώδης ακτινοβολία; Κάνε κλικ στον ήλιο για να το μάθεις. Θα μπορείς να παρακολουθείς το επίπεδο υπεριώδους ακτινοβολίας κάνοντας κλικ στον ήλιο, σε όλη τη διάρκεια του παιχνιδιού.', 
                type: QuestionType.SectionBreak,
                required: true,
                contenthidden :'Πόση να είναι τώρα άραγε, η υπεριώδης ακτινοβολία;',
                bar1: true,
                hero: true,
                sun: true,
                correct :2


              }),
              new QuestionModel({
                id: 'dx_6',
                content: 'Η ώρα είναι 8 το πρωί. Το επίπεδο υπεριώδους ακτινοβολίας κατά τις πρώτες πρωινές ώρες είναι σε χαμηλό επίπεδο και έτσι δε χρειάζεται προστασία.', 
                type: QuestionType.SectionBreak,
                required: true,
                contenthidden :'UV index: 0-2. Χαμηλό επίπεδο UV. Δε χρειάζεται προστασία.',
                bar1: true,
                sun1:true
              }),
              new QuestionModel({
                id: 'dx_7',
                content: 'Η ώρα πήγε 9 το πρωί. Άραγε η υπεριώδης ακτινοβολία παραμένει στο ίδιο χαμηλό επίπεδο; Κάνε κλικ στον ήλιο για να δεις το επίπεδο υπεριώδους ακτινοβολίας αυτή την ώρα.',                 type: QuestionType.SectionBreak,
                required: true,
                bar1: true,
                hero: true,
                sun: true,
                correct :2
              }),
              new QuestionModel({
                id: 'dx_8',
                content: 'Η ώρα είναι 9 το πρωί. Το επίπεδο υπεριώδους ακτινοβολίας αρχίζει να αυξάνεται, γι’ αυτό πρέπει να λάβουμε μέτρα προστασίας. Τι θα μπορούσες να λάβεις για προστασία;', 
                type: QuestionType.SectionBreak,
                required: true,
                contenthidden :'UV index: 3-7. Μέτριο επίπεδο UV. Χρειάζεται προστασία.',
                bar1: true,
                sun2:true,
                uvindex:false
              }),
              new QuestionModel({
                    id: 'dx_9',
                    subtitle: '«Στη χώρα του Ήλιου για να πας, στο κεφάλι πρέπει να το φοράς.»',
                    type: QuestionType.MultipleChoice,
                    helptext:'Λύσε το γρίφο',
                    multiple: false,
                    required: true,
                    bar1:true,
                    options: [
                      new ChoiceOption({
                        label: 'Καπέλο',
                        value: 'dx_9_b'
                      }),
                      new ChoiceOption({
                        label: 'Αντηλιακό',
                        value: 'dx_9_a'
                      }),
                      new ChoiceOption({
                        label: 'Σκουλαρίκια',
                        value: 'dx_9_a'
                      }),
                      new ChoiceOption({
                        label: 'Γυαλιά',
                        value: 'dx_9_a'
                      })
                    ],
                    jump: {
                      dx_9_a: 'dx_9_a',
                      dx_9_b: 'dx_9_b'
                    }
                  }),
                  new QuestionModel({
                    id: 'dx_9_a',
                    content: 'Το καπέλο είναι αυτό που δεν πρέπει να ξεχνώ.', 
                    type: QuestionType.SectionBreak,
                    bar1:true,
                    required: true,
                    jump: {
                        _other: 'dx_10'
                      }
                  }), 
                  new QuestionModel({
                    id: 'dx_9_b',
                    content: 'Μπράβο! Πρέπει να φοράμε στο κεφάλι, καπέλο.', 
                    type: QuestionType.SectionBreak,
                    bar1:true,
                    required: true,
                    jump: {
                        _other: 'dx_10'
                      },
                    point:20
                  }),   
                new QuestionModel({
                  id: 'dx_10',
                  content: 'Μέρος της πανοπλίας σου, καθώς πλησιάζεις τη Χώρα του Ήλιου είναι ένα καπέλο. Επιλέγοντας το καπέλο που θα σε προστατέψει περισσότερο μπορείς να κερδίσεις αρκετά νομίσματα! Η πωλήτρια θα σου εξηγήσει τις διαφορές τους, για να μπορέσεις να επιλέξεις.',
                 type: QuestionType.SectionBreak,
                  required: true,
                  bar1: true,
                  hero: true,
                  correct :2
                }),
              new QuestionModel({
                id: 'dx_11',
                tagline: 'Για να επιλέξουμε ένα καπέλο που πέρα από στυλ να δίνει και προστασία από την υπεριώδη ακτινοβολία του ήλιου θα πρέπει: να καλύπτει όλη την επιφάνεια του κεφαλιού να έχει φαρδύ γείσο ώστε να σκιάζει το μέρος του προσώπου, του λαιμού, του αυχένα και των αυτιών να είναι κατασκευασμένο από βαμβακερό ύφασμα και όσο πιο σκούρο, τόσο το καλύτερο.',
                helpTextShow: false,
                type: QuestionType.MultiplePictureChoice,
                multiple: true,
                required: false,
                bar1: true,
                granny: true,
                correct:2,
                options: [
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/cuphat.png'),
                    imageAlt: 'Jockey hat',
                    label: 'Καπέλα «Jockey»',
                    value: 1,
                    fake:1,
                    flag1:1,
                    contentchoice:'Jockey'
                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/psathinohat.png'),
                    imageAlt: 'Psathina hat',
                    label: 'Ψάθινα καπέλα',
                    value:2,
                    fake:1,
                    flag2:1,
                    contentchoice:'Psathina'

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/roundhat.png'),
                    imageAlt: 'Round hat',
                    label: 'Καπέλα «Bucket»',
                    value:3,
                    fake:1,
                    flag3:1,
                    contentchoice:'Round'

                  }),
                ],jump: {
                    1: 'dx_12',
                    3: 'dx_12',
                    2: 'dx_12'
                  }
              }),
              new QuestionModel({
                id: 'dx_12',
                subtitle: 'Με βάση τις πληροφορίες που έμαθες για τα καπέλα, επέλεξε εκείνο που θα σε προστατέψει περισσότερο από την υπεριώδη ακτινοβολία του ήλιου.',
                helpTextShow: false,
                type: QuestionType.MultiplePictureChoice,
                multiple: false,
                required: true,
                bar1: true,
                hero: true,
                correct:2,
                options: [
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/cuphat.png'),
                    imageAlt: 'Jockey hat',
                    label: 'Καπέλα «Jockey»',
                    value: 1
                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/psathinohat.png'),
                    imageAlt: 'Psathina hat',
                    label: 'Ψάθινα καπέλα',
                    value:2
                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/roundhat.png'),
                    imageAlt: 'Round hat',
                    label: 'Καπέλα «Bucket»',
                    value:3
                  }),
                ],jump: {
                    1: 'dx_12_a',
                    3: 'dx_12_b',
                    2: 'dx_12_c'
                  }
              }),new QuestionModel({
                id: 'dx_12_a',
                content: 'Πολύ καλή επιλογή. Το καπέλο αυτό αν και προστατεύει τα μάτια και το πρόσωπο, δεν καλύπτει τα αυτιά και το πίσω μέρος του λαιμού που χρειάζονται και αυτά προστασία. Επιπλέον προστασία θα χρειαστεί για τις περιοχές αυτές. Καπέλα τύπου Bucket μας προστατεύουν αποτελεσματικά.', 
                type: QuestionType.SectionBreak,
                required: true,
                bar1: true,
                point:10,
                jump: {
                        _other: 'dx_13'
                      },
              }),
              new QuestionModel({
                id: 'dx_12_b',
                content: 'Εξαιρετική επιλογή. Τα πλατύγυρα καπέλα τύπου «καμπάνα» μας προστατεύουν αποτελεσματικά απο την υπεριώδη ακτινοβολία, καλύπτοντας αποτελεσματικά ευαίσθητα σημεία όπως τα μάτια, τα αυτιά και το πίσω μέρος του λαιμού.', 
                type: QuestionType.SectionBreak,
                required: true,
                bar1: true,
                point:15,  
                jump: {
                        _other: 'dx_13'
                      },
              }),
              new QuestionModel({
                id: 'dx_12_c',
                content: 'Αποφεύγετε, τα ψάθινα καπέλα με τρύπες που αφήνουν το φως του ήλιου να περάσει. Ένα πιο σκούρο καπέλο μπορεί να προσφέρει μεγαλύτερη προστασία από την υπεριώδη ακτινοβολία. Καπέλα τύπου Bucket μας προστατεύουν αποτελεσματικά.', 
                type: QuestionType.SectionBreak,
                required: true,
                point:5,
                bar1: true,
                jump: {
                        _other: 'dx_13'
                      },
              }),
              new QuestionModel({
                id: 'dx_13',
                content: 'Συγχαρητήρια! Ολοκλήρωσες επιτυχώς τη 2η δοκιμασία και εξασφάλισες το καπέλο που είναι σημαντικό μέτρο προστασίας από την υπεριώδη ακτινοβολία του ήλιου.', 
                type: QuestionType.SectionBreak,
                required: true,
                roundhat: true,
                bar2: true
              }),
              new QuestionModel({
                id: 'dx_14',
                content: 'Η ώρα πήγε 11 το πρωί. Κάνε κλικ στον ήλιο για να δεις πόσο είναι τώρα το επίπεδο υπεριώδους ακτινοβολίας.',
                type: QuestionType.SectionBreak,
                required: true,
                bar2: true,
                hero: true,
                sun: true,
                correct :2
              }),
              new QuestionModel({
                id: 'dx_15',
                content: 'Η ώρα είναι 11 το πρωί. Το επίπεδο υπεριώδους ακτινοβολίας είναι αρκετά ψηλό. Τι θα μπορούσες να προσθέσεις για επιπλέον προστασία από την υπεριώδη ακτινοβολία του ήλιου;', 
                type: QuestionType.SectionBreak,
                required: true,
                contenthidden :'UV index: 8-10. Ψηλό επίπεδο UV. Χρειάζεται προστασία.',
                bar2: true,
                sun3:true
              }),
              new QuestionModel({
                    id: 'dx_16',
                    title: 'Λύσε το γρίφο',
                    subtitle: '«Στον ήλιο έξω σα θα βγεις, φόρεσέ τα μην αργείς, γιατί τα μάτια κινδυνεύουν και χωρίς αυτά δε μένουν.»',
                    type: QuestionType.MultipleChoice,
                    multiple: false,
                    required: true,
                    bar2: true,
                    options: [
                      new ChoiceOption({
                        label: 'Γυαλιά ηλίου',
                        value: 'dx_16_a'
                      }),
                      new ChoiceOption({
                        label: 'Σκιές ματιών',
                        value: 'dx_16_b'
                      }),
                      new ChoiceOption({
                        label: 'Σταγονίτσες ματιών',
                        value: 'dx_16_b'
                      })
                    ],
                    jump: {
                      dx_16_a: 'dx_16_a',
                      dx_16_b: 'dx_16_b'
                    }
                  }),new QuestionModel({
                id: 'dx_16_a',
                content: 'Μπράβο! Πρέπει να φοράμε γυαλιά ηλίου.', 
                type: QuestionType.SectionBreak,
                required: true,
                point:20,
                bar2: true,
                jump: {
                        _other: 'dx_17'
                      },
              }),new QuestionModel({
                id: 'dx_16_b',
                content: 'Τα γυαλιά ηλίου είναι αυτά που πρέπει να φοράς.', 
                type: QuestionType.SectionBreak,
                required: true,  
                bar2: true,
                jump: {
                        _other: 'dx_17'
                      },
              }),
              new QuestionModel({
                  id: 'dx_17',
                  content: 'Μέρος της πανοπλίας σου, καθώς πλησιάζεις τη Χώρα του Ήλιου πρέπει να είναι και ένα ζευγάρι γυαλιά ηλίου. Επιλέγοντας τα γυαλιά ηλίου που θα σε προστατέψουν από την υπεριώδη ακτινοβολία του ήλιου θα κερδίσεις και άλλα νομίσματα. Η οπτικός θα σου εξηγήσει τις διαφορές τους, για να μπορέσεις να επιλέξεις.',
                 type: QuestionType.SectionBreak,
                  required: true,
                  bar2: true,
                  hero: true,
                  correct :2
                }),
                new QuestionModel({
                id: 'dx_18',
                subtitle: 'Τα γυαλιά ηλίου είναι απαραίτητα για την προστασία των ματιών μας και του δέρματος γύρω από αυτά από την υπεριώδη ακτινοβολία του ήλιου. Πρέπει να επιλέγουμε ποιοτικά γυαλιά που μας παρέχουν πλήρη προστασία από την υπεριώδη ακτινοβολία του ήλιου. Η ένδειξη UV400 ή 100% προστασία UV που αναγράφεται στα γυαλιά υποδηλώνει ότι οι συγκεκριμένοι φακοί μπλοκάρουν ακόμη και τις πιο λεπτές ακτίνες UV και τα μάτια σας είναι προστατευμένα από αυτές. Οι πολωτικοί φακοί δεν προσφέρουν επιπλέον προστασία από την υπεριώδη ακτινοβολία, αν και εξαλείφουν το έντονο φως.',
                helpTextShow: false,
                type: QuestionType.MultiplePictureChoice,
                multiple: true,
                required: false,
                bar2: true,
                glassdoc: true,
                correct:2,
                options: [
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/glasses.png'),
                    imageAlt: 'Πολωτικά γυαλιά',
                    label: 'Πολωτικά γυαλιά',
                    value: 1,
                    fake:1,
                    flag1:1,
                    contentchoice:'Πολωτικά γυαλιά'

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/glasses.png'),
                    imageAlt: 'Γυαλιά (100% προστασία UV)',
                    label: 'Γυαλιά (100% προστασία UV)',
                    value:2,
                    fake:1,
                    flag2:1,
                    contentchoice:'Γυαλιά (100% προστασία UV)'

                  }),
                ],jump: {
                    1: 'dx_19',
                    2: 'dx_19'
                  }
              }),
              new QuestionModel({
                id: 'dx_19',
                subtitle: 'Με βάση τις πληροφορίες που έμαθες για τα γυαλιά ηλίου, επέλεξε εκείνα που θα σε προστατέψουν από την υπεριώδη ακτινοβολία του ήλιου.',
                helpTextShow: false,
                type: QuestionType.MultiplePictureChoice,
                multiple: false,
                required: true,
                bar2: true,
                hero: true,
                correct:2,
                options: [
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/glasses.png'),
                    imageAlt: 'Πολωτικά γυαλιά',
                    label: 'Πολωτικά γυαλιά',
                    value: 1
                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/images/glasses.png'),
                    imageAlt: 'Γυαλιά (100% προστασία UV)',
                    label: 'Γυαλιά (100% προστασία UV)',
                    value:2
                  }),
                ],jump: {
                    1: 'dx_19_a',
                    2: 'dx_19_b'
                  }
              }),
              new QuestionModel({
                id: 'dx_19_a',
                content: 'Τα πολωτικά γυαλιά δεν προσφέρουν πάντοτε προστασία από την υπεριώδη ακτινοβολία. Θα πρέπει να ρωτήσετε τον οπτικό σας αν τα πολωτικά σας γυαλιά ηλίου μπλοκάρουν 100% την υπεριώδη ακτινοβολία ή όχι.', 
                type: QuestionType.SectionBreak,
                required: true,
                bar2: true,
                jump: {
                        _other: 'dx_20'
                      },
              }),new QuestionModel({
                id: 'dx_19_b',
                content: 'Εξαιρετική επιλογή. Όταν πρόκειται να αγοράσεις γυαλιά που προσφέρουν «100% προστασία» από την UV υπεριώδη ακτινοβολία σημαίνει ότι τα συγκεκριμένα γυαλιά διαθέτουν φίλτρο που μπλοκάρει την υπεριώδη ακτινοβολία και άρα τα μάτια σου προστατεύονται από αυτή.', 
                type: QuestionType.SectionBreak,
                required: true,  
                point: 5, 
                bar2: true,
                jump: {
                        _other: 'dx_20'
                      },
              }),
              new QuestionModel({
                id: 'dx_20',
                content: 'Συγχαρητήρια! Ολοκλήρωσες επιτυχώς την 3η δοκιμασία και εξασφάλισες τα γυαλιά ηλίου, που αποτελούν ένα σημαντικό μέτρο προστασίας από την υπεριώδη ακτινοβολία του ήλιου.', 
                type: QuestionType.SectionBreak,
                required: true,
                bar3: true,
                glassprice :true
              }),
              new QuestionModel({
                id: 'dx_21',
                content: 'Η ώρα πήγε 1 μετά το μεσημέρι. Κάνε κλικ στον ήλιο για να δεις τώρα το επίπεδο υπεριώδους ακτινοβολίας.',
                type: QuestionType.SectionBreak,
                required: true,
                bar3: true,
                hero: true,
                sun: true,
                correct :2
              }),
              new QuestionModel({
                id: 'dx_22',
                content: 'Η ώρα είναι 1 μετά μεσημέρι. Το επίπεδο υπεριώδους ακτινοβολίας είναι εξαιρετικά ψηλό. Τι θα μπορούσες να προσθέσεις;', 
                type: QuestionType.SectionBreak,
                required: true,
                contenthidden :'UV index: 11+. Εξαιρετικά ψηλό επίπεδο UV. Αποφυγή μετακινήσεων τις μεσημβρινές ώρες.',
                bar3: true,
                sun4:true
              }),
              new QuestionModel({
                    id: 'dx_23',
                    title: 'Λύσε το γρίφο',
                    subtitle: '«Απλώνεται με το χεράκι και προστατεύει το δερματάκι.»',
                    type: QuestionType.MultipleChoice,
                    multiple: false,
                    required: true,
                    bar3: true,
                    options: [
                      new ChoiceOption({
                        label: 'Κρέμα σώματος',
                        value: 'dx_23_b'
                      }),
                      new ChoiceOption({
                        label: 'Αντηλιακή κρέμα',
                        value: 'dx_23_a'
                      }),
                      new ChoiceOption({
                        label: 'Λαδάκι',
                        value: 'dx_23_b'
                      })
                    ],
                    jump: {
                      dx_23_a: 'dx_23_a',
                      dx_23_b: 'dx_23_b'
                    }
                  }),              
              new QuestionModel({
                id: 'dx_23_b',
                content: 'Την αντηλιακή κρέμα χρησιμοποιούμε.', 
                type: QuestionType.SectionBreak,
                required: true,
                bar3: true,
                jump: {
                        _other: 'dx_24'
                      },
              }),new QuestionModel({
                id: 'dx_23_a',
                content: 'Μπράβο! Πρέπει να βάζουμε αντηλιακή κρέμα.', 
                type: QuestionType.SectionBreak,
                required: true,  
                point: 20, 
                bar3: true,
                jump: {
                        _other: 'dx_24'
                      },
              }),
              new QuestionModel({
                  id: 'dx_24',
                  content: 'Μέρος της πανοπλίας σου, καθώς πλησιάζεις τη Χώρα του Ήλιου πρέπει να είναι και μια αντηλιακή κρέμα. Επιλέγοντας το αντηλιακό που θα σε προστατέψει από τα πολύ υψηλά επίπεδα υπεριώδους ακτινοβολίας εκεί στη χώρα του ήλιου θα κερδίσεις ακόμη περισσότερα νομίσματα. Ο δερματολόγος θα σου εξηγήσει πώς να επιλέξεις το σωστό αντηλιακό, αφού πρώτα παρακολουθήσεις με προσοχή το βίντεο.',
                  type: QuestionType.SectionBreak,
                  required: true,
                  bar3: true,
                  hero: true,
                  correct :2
                }),
                new QuestionModel({
                  id: 'dx_25',
                  content: 'ΒΙΝΤΕΟ ΔΕΡΜΑΤΟΛΟΓΟΥ',
                  type: QuestionType.SectionBreak,
                  required: true,
                  bar3: true,
                  video1: true
                }),
                new QuestionModel({
                  id: 'dx_25',
                  content: 'ΒΙΝΤΕΟ ΔΕΡΜΑΤΟΛΟΓΟΥ 2',
                  type: QuestionType.SectionBreak,
                  required: true,
                  bar3: true,
                  video2: true
                }),
                new QuestionModel({
                  id: 'dx_25_1',
                  content: 'Ας θυμηθούμε τι έχουμε μάθει για τη χρήση των αντηλιακών. Τα αντηλιακά είναι η ασπίδα προστασίας του σώματος από την υπεριώδη ακτινοβολία. Υπάρχουν δύο τύπου αντηλιακών, οι οργανικοί και οι ανόργανοι αναστολείς. Οι οργανικοί αναστολείς δημιουργούν ένα φυσικό φράγμα προστασίας αντανακλώντας τις υπεριώδεις ακτίνες, ενώ οι ανόργανοι αναστολείς τις απορροφούν γι’ αυτό καταστρέφονται και πιο γρήγορα. Όλα τα αντηλιακά υποβάλλονται σε δοκιμές για να καθοριστεί ο παράγοντας προστασίας από τον ήλιο (SPF), ο χρόνος προστασίας που παρέχει το αντηλιακό πριν το σώμα καεί από τον ήλιο. Για καθημερινή χρήση επιλέγουμε αντηλιακό με δείκτη προστασίας 30 και το εφαρμόζουμε 15 – 30 λεπτά πριν βγούμε έξω και αμέσως μετά την έκθεση μας στον ήλιο. Δεν ξεχνούμε να το αναενώνουμε κάθε 2-3 ώρες.',
                  type: QuestionType.SectionBreak,
                  required: true,
                  bar3: true,
                  dermatologist: true,
                  correct :2
                }),
                new QuestionModel({
                id: 'dx_26',
                subtitle: 'Από την άνοιξη, οπότε η διάρκεια της ημέρας αυξάνεται, προσέχουμε την αντηλιακή μας προστασία. Όταν αγοράζουμε αντηλιακά πρέπει να προσέχουμε τα ακόλουθα: Επιλέγουμε αντηλιακά ευρέως φάσματος, αφού αυτά μας προστατεύουν και από τα δύο είδη ακτινών UV που φτάνουν στην επιφάνεια της γης: τις UVA που ευθύνονται για πρόωρη γήρανση, ρυτίδες και πανάδες και τις UVB που προκαλούν εγκαύματα στο δέρμα μας. Κοιτάζουμε τον δείκτη προστασίας (SPF) ανάλογα με την ηλικία στην περίπτωση των παιδιών, γιατί για τους ενήλικες είναι σημαντικός και ο τύπος δέρματος. Για παιδιά ηλικίας 6-10 ετών συστήνεται η χρήση αντηλιακών με SPF 30-50.',
                helpTextShow: false,
                type: QuestionType.MultiplePictureChoice,
                multiple: true,
                required: false,
                bar3: true,
                correct :2,
                dermatologist: true,
                options: [
                  new ChoiceOption({
                    imageSrc: require('./assets/images/SunScreen15_black.png'),
                    value: 1,
                    label: 'Δείκτης προστασίας 15 - ευρέως φάσματος',

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/Sunscreen30_black.png'),
                    value:2,
                    label: 'Δείκτης προστασίας 30 - ευρέως φάσματος',

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/sunscreen30c.png'),
                    value:3,
                    label: 'Δείκτης προστασίας 30',

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/Sunscreen50_black.png'),
                    value:4,
                    label: 'Δείκτης προστασίας 50 - ευρέως φάσματος',

                  }),
                ],jump: {
                    1: 'dx_27',
                    2: 'dx_27',
                    3:'dx_27',
                    4:'dx_27'
                  }
              }),
              new QuestionModel({
                id: 'dx_27',
                subtitle: 'Με βάση τις πληροφορίες που έμαθες για τα αντηλιακά, ποιο αντηλιακό θα σε προστατέψει από τα πολύ υψηλά επίπεδα υπεριώδους ακτινοβολίας που επικρατούν αρκετές ώρες της μέρας στη Χώρα του Ήλιου; Κάνε κλικ σε αυτό που επιλέγεις.',
                helpTextShow: false,
                type: QuestionType.MultiplePictureChoice,
                multiple: false,
                required: true,
                bar3: true,
                hero: true,
                correct :2,
                options: [
                  new ChoiceOption({
                    imageSrc: require('./assets/images/SunScreen15_black.png'),
                    value: 1,
                    label: 'Δείκτης προστασίας 15 - ευρέως φάσματος',

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/Sunscreen30_black.png'),
                    value:2,
                    label: 'Δείκτης προστασίας 30 - ευρέως φάσματος',

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/sunscreen30c.png'),
                    value:3,
                    label: 'Δείκτης προστασίας 30',

                  }),
                  new ChoiceOption({
                    imageSrc: require('./assets/images/Sunscreen50_black.png'),
                    value:4,
                    label: 'Δείκτης προστασίας 50 - ευρέως φάσματος',

                  }),
                ],jump: {
                    1: 'dx_27_1',
                    2: 'dx_27_2',
                    3: 'dx_27_3',
                    4: 'dx_27_4'
                  }
              }),
              new QuestionModel({
                id: 'dx_27_1',
                content: 'Θα μπορούσες να χρησιμοποιήσεις αντηλιακό με υψηλότερο δείκτη προστασίας, ειδικά τις ώρες που ο ήλιος γίνεται εντονότερος (10:00-17:00)', 
                type: QuestionType.SectionBreak,
                required: true,  
                point: 5, 
                bar3: true,
                jump: {
                        _other: 'dx_28'
                      },
              })
              ,new QuestionModel({
                id: 'dx_27_2',
                content: 'Πολύ καλή επιλογή, αν έχεις σκουρόχρωμη επιδερμίδα. Σε προστατεύει και από τις UVA και UVB.', 
                type: QuestionType.SectionBreak,
                required: true,
                bar3: true,  
                point: 10, 
                jump: {
                        _other: 'dx_28'
                      },
              })
              ,new QuestionModel({
                id: 'dx_27_3',
                content: 'Το αντηλιακό δεν είναι ευρέως φάσματος. Προστατεύει από τη UVB, όχι όμως και από τη UVA. Επιλέγω αντηλιακό ευρεύως φάσματος και με δείκτη προστασίας πάνω από 15.', 
                type: QuestionType.SectionBreak,
                required: true,  
                bar3: true,
                jump: {
                        _other: 'dx_28'
                      },
              })
              ,new QuestionModel({
                id: 'dx_27_4',
                content: 'Εξαιρετική επιλογή. Το αντηλιακό αυτό σε προστατεύει και από τις UVA και UVB ειδικά αν έχεις ανοιχτόχρωμη επιδερμίδα πρέπει να χρησιμοποιείς αντηλιακό με δείκτη προστασίας 50+.', 
                type: QuestionType.SectionBreak,
                required: true,  
                bar3: true,
                point: 15, 
                jump: {
                        _other: 'dx_28'
                      },
              })
              ,
                        
           
            ],
            questions2a: [   new QuestionModel({
                id: 'dx_28',
                content: 'Συγχαρητήρια! Ολοκλήρωσες επιτυχώς την 4η δοκιμασία και εξασφάλισες την αντηλιακή κρέμα. Μάζεψες '+this.pointsTotal+' νομίσματα ως τώρα και μπορείς να μαζέψεις ακόμη περισσότερα με το τελικό κουιζ!', 
                type: QuestionType.SectionBreak,
                required: true,
                bar4: true,
                sunscreenprice:true
              }),],
            questions3: [
            new QuestionModel({
                id: 'fqstart',
                content: 'Μπράβο! Τα κατάφερες να φτάσεις με την πανοπλία σου στη Χώρα του Ήλιου! Οι νόμοι προστασίας εδώ είναι πολύ αυστηροί. Έτσι, πριν σου επιτραπεί η είσοδος θα πρέπει να απαντήσεις σε ένα κουίζ ερωτήσεων σχετικό με τα όσα έχεις μάθεις στη διαδρομή του ταξιδιού σου για την υπεριώδη ακτινοβολία! Καλή επιτυχία!',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct :2
              }),
              new QuestionModel({
                id: 'fq_1',
                subtitle: 'Η υπεριώδης ακτινοβολία είναι ένα είδος ηλιακής ακτινοβολίας.',
                helpTextShow: false,
                bar4:true,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_1_a',
                    false: 'fq_1_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_1_a',
                content: 'Φυσική πηγή της υπεριώδους ακτινοβολίας είναι ο ήλιος. Διακρίνεται σε UVA, UVB και UVC. H UVC δε διαπερνά το όζον, σε αντίθεση με τις UVA και UVB που φτάνουν στην επιφάνεια της γης.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point: 5,
                correct:2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_1_b',
                content: 'Φυσική πηγή της υπεριώδους ακτινοβολίας είναι ο ήλιος. Διακρίνεται σε UVA, UVB και UVC. H UVC δε διαπερνά το όζον, σε αντίθεση με τις UVA και UVB που φτάνουν στην επιφάνεια της γης.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1 ,
                  jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_2',
                subtitle: 'Αρκετή ώρα στον ήλιο χωρίς προστασία μπορεί να κάνει κακό στο δέρμα και στα μάτια.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                bar4:true,
                multiple: false,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_2_a',
                    false: 'fq_2_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_2_a',
                content: 'Η υπερβολική έκθεση στην υπεριώδη ακτινοβολία του ήλιου, χωρίς προστασία μπορεί να προκαλέσει βλάβες στα μάτια και στο δέρμα.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point:5,
                correct:2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_2_b',
                content: 'Η υπερβολική έκθεση στην υπεριώδη ακτινοβολία του ήλιου, χωρίς προστασία μπορεί να προκαλέσει βλάβες στα μάτια και στο δέρμα.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_3',
                subtitle: 'Το επίπεδο υπεριώδους ακτινοβολίας είναι ψηλό όλη τη διάρκεια της μέρας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_3_a',
                    false: 'fq_3_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_3_a',
                content: 'Το επίπεδο υπεριώδους ακτινοβολίας δεν είναι το ίδιο κατά τη διάρκεια της ημέρας. Ψηλότερα επίπεδα υπεριώδους ακτινοβολίας παρουσιάζονται μεταξύ των ωρών 10:00 – 16:00.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_3_b',
                content: 'Το επίπεδο υπεριώδους ακτινοβολίας δεν είναι το ίδιο κατά τη διάρκεια της ημέρας. Ψηλότερα επίπεδα υπεριώδους ακτινοβολίας παρουσιάζονται μεταξύ των ωρών 10:00 – 16:00.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_4',
                subtitle: 'Ο δείκτης UV (UV index) μας δείχνει το επίπεδο επικινδυνότητας της υπεριώδους ακτινοβολίας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_4_a',
                    false: 'fq_4_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_4_a',
                content: 'Ο δείκτης UV (UV index) προβλέπει τα επίπεδα υπεριώδους ακτινοβολίας της επόμενης μέρας σε μια κλίμακα από το 0 έως 10+. Βοηθά τον κόσμο να γνωρίζει το επίπεδο υπεριώδους ακτινοβολίας για να μπορούν να εφαρμόσουν μέτρα προστασίας από τον ήλιο.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_4_b',
                content: 'Ο δείκτης UV (UV index) προβλέπει τα επίπεδα υπεριώδους ακτινοβολίας της επόμενης μέρας σε μια κλίμακα από το 0 έως 10+. Βοηθά τον κόσμο να γνωρίζει το επίπεδο υπεριώδους ακτινοβολίας για να μπορούν να εφαρμόσουν μέτρα προστασίας από τον ήλιο.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_5',
                subtitle: 'Προτιμούμε αντηλιακά με την ένδειξη «ευρέως φάσματος».',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                required: true,
                bar4:true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_5_a',
                    false: 'fq_5_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_5_a',
                content: 'Φυσική πηγή της υπεριώδους ακτινοβολίας είναι ο ήλιος. Διακρίνεται σε UVA, UVB και UVC. H UVC δε διαπερνά το όζον, σε αντίθεση με τις UVA και UVB που φτάνουν στην επιφάνεια της γης.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_5_b',
                content: 'Φυσική πηγή της υπεριώδους ακτινοβολίας είναι ο ήλιος. Διακρίνεται σε UVA, UVB και UVC. H UVC δε διαπερνά το όζον, σε αντίθεση με τις UVA και UVB που φτάνουν στην επιφάνεια της γης.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_6',
                subtitle: 'Βάζοντας μια φορά αντηλιακό προστατεύεις το δέρμα σου για τουλάχιστον 4 ώρες.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_6_a',
                    false: 'fq_6_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_6_a',
                content: 'Ο βασικός κανόνας για να είμαστε πάντοτε προστατευόμενοι από τον ήλιο είναι να βάζουμε αντηλιακό 20-30 λεπτά πριν εκτεθούμε στην ηλιακή ακτινοβολία και μετά κάθε δύο ώρες.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_6_b',
                content: 'Ο βασικός κανόνας για να είμαστε πάντοτε προστατευόμενοι από τον ήλιο είναι να βάζουμε αντηλιακό 20-30 λεπτά πριν εκτεθούμε στην ηλιακή ακτινοβολία και μετά κάθε δύο ώρες.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_7',
                subtitle: 'Ένα αντηλιακό με δείκτη προστασίας 15, είναι αρκετό για να μας προστατέψει.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_7_a',
                    false: 'fq_7_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_7_a',
                content: 'Ένα αντηλιακό ευρέως φάσματος με δείκτη προστασίας από 30+ μπορεί να μας προστατέψει από την υπεριώδη ακτινοβολία του ήλιου. Για ανοιχτόχρωμες επιδερμίδες ο δείκτης προστασίας συστήνεται να είναι 50+.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_7_b',
                content: 'Ένα αντηλιακό ευρέως φάσματος με δείκτη προστασίας από 30+ μπορεί να μας προστατέψει από την υπεριώδη ακτινοβολία του ήλιου. Για ανοιχτόχρωμες επιδερμίδες ο δείκτης προστασίας συστήνεται να είναι 50+.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_8',
                subtitle: 'Πρέπει να φοράμε γυαλιά ηλίου όταν είμαστε στον ήλιο, γιατί ο ήλιος μπορεί να βλάψει τα μάτια μας.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],jump: {
                    true: 'fq_8_a',
                    false: 'fq_8_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_8_a',
                content: 'Η υπεριώδης ακτινοβολία μπορεί να προκαλέσει βλάβες στα μάτια, γι’ αυτό τα γυαλιά του ήλιου είναι απαραίτητα, ακόμη και για ημέρες με συννεφιά, αφού η υπεριώδης ακτινοβολία δεν αντανακλάτε από τα σύννεφα.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_8_b',
                content: 'Η υπεριώδης ακτινοβολία μπορεί να προκαλέσει βλάβες στα μάτια, γι’ αυτό τα γυαλιά του ήλιου είναι απαραίτητα, ακόμη και για ημέρες με συννεφιά, αφού η υπεριώδης ακτινοβολία δεν αντανακλάτε από τα σύννεφα.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_9',
                subtitle: 'Όλα τα γυαλιά ηλίου μας προστατεύουν τα μάτια από την υπεριώδη ακτινοβολία του ήλιου.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_9_a',
                    false: 'fq_9_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_9_a',
                content: 'Γυαλιά ηλίου με την ένδειξη «100% προστασία UV» μπορούν να μας προστατέψουν από την υπεριώδη ακτινοβολία του ήλιου. Μπορούμε να ελέξουμε τα γυαλιά μας σε έναν οπτικό.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_9_b',
                content: 'Γυαλιά ηλίου με την ένδειξη «100% προστασία UV» μπορούν να μας προστατέψουν από την υπεριώδη ακτινοβολία του ήλιου. Μπορούμε να ελέξουμε τα γυαλιά μας σε έναν οπτικό.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_10',
                subtitle: 'Όταν ο δείκτης UV είναι στο 2, τότε μπορούμε να μείνουμε όση ώρα θέλουμε στον ήλιο, χωρίς προστασία.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_10_a',
                    false: 'fq_10_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_10_a',
                content: 'Ένδειξη 2, στον Δείκτη UV δείχνει χαμηλό επίπεδο υπεριώδους ακτινοβολίας και έτσι μπορούμε να είμαστε εκτεθειμένοι στον ήλιο χωρίς προστασία. Τέτοιες τιμές παρουσιάζονται νωρίς το πρωί ή αργά το απόγευμα.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_10_b',
                content: 'Ένδειξη 2, στον Δείκτη UV δείχνει χαμηλό επίπεδο υπεριώδους ακτινοβολίας και έτσι μπορούμε να είμαστε εκτεθειμένοι στον ήλιο χωρίς προστασία. Τέτοιες τιμές παρουσιάζονται νωρίς το πρωί ή αργά το απόγευμα.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_11',
                subtitle: 'Όταν βάζεις αντηλιακό δε χρειάζεται να φοράς καπέλο ή γυαλιά όταν βρίσκεσαι στον ήλιο.',
                helpTextShow: false,
                type: QuestionType.MultipleChoice,
                multiple: false,
                bar4:true,
                required: true,
                options: [
                  new ChoiceOption({
                    label: 'ΣΩΣΤΟ', 
                    value: 'true'
                  }),
                  new ChoiceOption({
                    label: 'ΛΑΘΟΣ', 
                    value: 'false'
                  })
                ],
                jump: {
                    true: 'fq_11_a',
                    false: 'fq_11_b'
                  }
              }),
              new QuestionModel({
                id: 'fq_11_a',
                content: 'Το αντηλιακό προστατεύει το δέρμα. Η έκθεση στην υπεριώδη ακτινοβολία μπορεί να προκαλέσει βλάβες και στα μάτια. Έτσι, το καπέλο και τα γυαλιά ηλίου είναι απαραίτητα για την προστασία τους.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                correct: 1,
                jump: {
                    _other: 'dx_2'
                  },
              }),
              new QuestionModel({
                id: 'fq_11_b',
                content: 'Το αντηλιακό προστατεύει το δέρμα. Η έκθεση στην υπεριώδη ακτινοβολία μπορεί να προκαλέσει βλάβες και στα μάτια. Έτσι, το καπέλο και τα γυαλιά ηλίου είναι απαραίτητα για την προστασία τους.',
                hero:true,
                bar4:true,
                type: QuestionType.SectionBreak,
                required: true,
                point :5,
                correct: 2,
                jump: {
                    _other: 'fq_1'
                  },
              }),
            
         
              
            ],
            questions4: [
            new QuestionModel({
                id: 'q4_1',
                tagline: '',
                subtitle: 'ΠΛΗΚΤΡΟΛΟΓΗΣΕ ΤΟ ΟΝΟΜΑ ΣΟΥ',
                type: QuestionType.Text,
                required: false,
                hero : false,
                bar : false,
              })],           
            id:0,
            questions1Shuffle:[],
            questions3Shuffle:[]


        }
    },

    mounted() {
     this.fetchUsers();
      document.addEventListener('keyup', this.onKeyListener);
      this.questions1Shuffle =[this.questions1[0],...this.shuffleList(this.questions1.slice(1))]; 

    this.questions3Shuffle = [this.questions3[0],...this.shuffleListWithPairs(this.questions3.slice(1))];
   
    },

    beforeUnmount() {
      document.removeEventListener('keyup', this.onKeyListener)
    },
    watch: {

    },
    methods: {
      async fetchUsers() {
        try {
          const response = await fetch("http://localhost/vue-flow-form/backend/api.php");
          const data = await response.json();    
          this.username = data[0].id;      
          this.$refs.flowform.UpdateAnswer(data[0].id);
        } catch (error) {
          console.error("Error fetching users:", error);
        }
     },
      shuffleListWithPairs(list) {
      // Create pairs of adjacent elements
      const pairs = [];
      for (let i = 0; i < list.length; i += 3) {
        pairs.push(list.slice(i, i + 3));
      }
      
      // Shuffle the pairs
      const shuffledPairs = this.shuffleList(pairs);

      // Flatten the shuffled pairs back into a single array
      const shuffledList = [].concat(...shuffledPairs);
      for (let i = 0; i < shuffledList.length - 1;  i++) {
        if (shuffledList[i + 1] && (i!=0 && i%3 !=0 )) {
    // Assign the value of the current object to the value of the next object
            if(i%3 ==1 && shuffledList[i + 2]){
                  shuffledList[i].jump._other =  shuffledList[i+2].id;
            }else if(i%3 ==2 && shuffledList[i + 1]){
              shuffledList[i].jump._other = shuffledList[i+1].id;

            }
        } 
      }
      return shuffledList;
    },
    finalstep(){
      this.finito = true;
      this.background = true;
    },
    ranktable(){
      this.flowChange();
    },
    showEndSlide(){
      this.finaloptions = true;
      this.background = true;
    },
    startagain(){
      window.location.reload();
    },
     populateTable() {
        const tableBody = document.querySelector("#data-table tbody");

        this.ranked_data.forEach((item) => {
            const row = document.createElement("tr");

            const nameCell = document.createElement("td");
            nameCell.textContent = item.name;
            row.appendChild(nameCell);

            const pointsCell = document.createElement("td");
            pointsCell.textContent = item.points;
            row.appendChild(pointsCell);

            tableBody.appendChild(row);
        });
    },

     removeOddIndexes(arr) {
        return arr.filter((_, index) => index % 2 === 0);
      },
      SavePointsEvent(poin){
       this.pointsTotal = poin
      },
      SavePointsEventFinal(poin){
       this.pointsTotalFinal = poin
      },
      arrayEquals(a, b) {
        return Array.isArray(a) && Array.isArray(b) && a.length === b.length &&
          a.every((val, index) => val === b[index])
      },
      shuffleList(array) {
      // Shuffle the list using Fisher-Yates algorithm
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },


     async calculateScore() {

        const data = {
          userid: this.username
        }
        //ux_1: this.questions1Shuffle
        //ux_2: this.ux_2 ? 1 : 0,
        // Map other checkboxes as needed
    

        this.questions1Shuffle.forEach(questions1Shuffle => {
          if (questions1Shuffle.type !== QuestionType.SectionBreak) {
            let answer = questions1Shuffle.answer
            data[questions1Shuffle.id] = answer;
            if (typeof answer === 'object') {
              answer.sort((a, b) => a - b)

              if (this.arrayEquals(answer, this.answers[questions1Shuffle.id])) {
                this.score++
              }
            }
            if (answer == this.answers[questions1Shuffle.id]) {

              this.score++
            }
          }
        })
        this.calcflag =true;

       /* try {
          const response = await fetch('http://localhost/vue-flow-form/backend/insertquiz1.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          });

          const result = await response.json();
          console.log('Success:', result);

          if (result.status === 'success') {
            alert('Data submitted successfully');
          } else {
            alert('Error: ' + result.message);
          }
        } catch (error) {
          console.error('Error:', error);
          alert('Error: ' + error.message);
        }
*/
      }, 
      calculateScoreFinal() {
        this.questions3Shuffle.forEach(questions3Shuffle => {
          if (questions3Shuffle.type !== QuestionType.SectionBreak) {
            let answersfinal = questions3Shuffle.answer
            if (typeof answersfinal === 'object') {
              answersfinal.sort((a, b) => a - b)

              if (this.arrayEquals(answersfinal, this.answersfinal[questions3Shuffle.id])) {
                this.scorefinal++
              }
            }
            if (answersfinal == this.answersfinal[questions3Shuffle.id]) {

              this.scorefinal++
            }
          }
        })
        this.calcflag =true;
      }, 
      async onQuizSubmit1() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform1.submitted = true
         

        this.submitted1 = true
        this.calculateScore()

      },
      onQuizSubmit2() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform2.submitted = true
        this.background = true;
        this.submitted2 = true

      },
      onQuizSubmit2a() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform2a.submitted = true
        this.background = true;
        this.submitted2 = true

      },
      onQuizSubmit3() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform3.submitted = true
      //  this.background = true;
        this.submitted3 = true
        this.calculateScoreFinal()


      },
      onQuizSubmit4() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform4.submitted = true
      //  this.background = true;
        this.submitted4 = true
        this.calculateScoreFinal()


      },
      onKeyListener($event) {
        // We've overriden the default "complete" slot so
        // we need to implement the "keyup" listener manually.

        if ($event.key === 'Enter' && this.completed && !this.submitted1){
          this.onSendData()
        }
        if ($event.key === 'Enter' && this.completed1 && this.submitted1 && this.calcflag){
          this.onSendData1();
        }
      },

      /* eslint-disable-next-line no-unused-vars */
      onComplete(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
        //this.completed = completed
        this.completed = completed;
        this.onSendData();

      },
      onComplete1(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
        this.completed1 = completed
        this.onQuizSubmit1();
      },
      onComplete2(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
       // this.completed = completed
        this.flowChange();
      },
      onComplete2a(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
       // this.completed = completed
        this.flowChange();
      },
      onComplete3(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
       // this.completed = completed
       this.completed3 = completed
        this.onQuizSubmit3();
      },
      onComplete4(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
       // this.completed = completed
       this.completed4 = completed
       this.populateTable();
      },
      /* eslint-disable-next-line no-unused-vars */
      onSubmit(questionList) {
        // This method will only be called if you don't override the
        // completeButton slot.
        this.onSendData()
      },
      
      onSendData() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform.submitted = true

        this.submitted = true

        /* eslint-disable-next-line no-unused-vars */
        const data = this.getData()
        this.flowChange()

        /*
          You can use Fetch API to send the data to your server, eg.:

          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
        */
      },
      onSendData1() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.


        /* eslint-disable-next-line no-unused-vars */
        this.flowChange()

        /*
          You can use Fetch API to send the data to your server, eg.:

          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
        */
      },
      getData() {
        const data = {
          questions: [],
          answers: []
        }

        this.questions.forEach(question => {
          if (question.title) {
            let answer = question.answer
            if (Array.isArray(answer)) {
              answer = answer.join(', ')
            }

            data.questions.push(question.title)
            data.answers.push(answer)
          }
        })

        return data
      },
      flowChange() {
               
        this.storyCount+=1;
          if (this.storyCount ==1) {
           this.showTime0=false
            this.showTime1 =true;

          }else if (this.storyCount ==2){
            this.showTime1=false
            this.showTime2 =true;
            this.background = false;

          }else if (this.storyCount ==3){
            this.showTime2=false
            this.showTime2a =true;
          }
          else if (this.storyCount ==4){
            this.showTime2a=false
            this.showTime3 =true;
          }
          else if (this.storyCount ==5){
            this.showTime3=false
            this.showTime4 =true;
          }
          else if (this.storyCount ==6){
            this.showTime4=false
            this.showTime5 =true;
          }
      }
    }
  }
</script>

<style lang="css">
  @import '../../src/assets/css/themes/theme-minimal.css';
  /* If using the npm package, use the following lines instead of the one above */
  /* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css'; */
  /* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-minimal.css'; */
</style>